// camelCase → "Camel Case" + first-letter uppercase. Used by the form
// generator to derive a default field label when a Zod schema does not
// provide a `.describe()` value. Per spec/tech-arch.md §7 ("Per-field
// labels and help text come from `.describe()`, falling back to a
// humanized field name").
//
// Note: handles common camelCase / pascalCase identifiers. Acronym runs
// (`htmlURL`) collapse to "Html URL" — acceptable for V1 since no current
// Block schema uses acronym runs.

export function humanize(name: string): string {
  return name.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/^./, (c) => c.toUpperCase())
}
